<template>
  <div
    v-if="visible"
    class="row mx-auto d-flex align-items-center panel-wrapper rounded px-4 py-3"
    :class="
      `bg-${customBackgroundColor} text-${customColor} border-${customBorderColor}`
    "
  >
    <i
      class="fas font-22 icon"
      :class="`${customIcon} text-${customIconColor}`"
    />
    <div class="content pl-3">
      {{ message }}
      <span v-if="hyperlinkConfig.text">
        -&nbsp;
        <a
          class="hyperlink"
          :class="`text-${customColor}`"
          @click="hyperlinkConfig.goTo"
        >
          {{ hyperlinkConfig.text }}
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InnerPageMessage',
  meta: {
    description: 'Componente para mostrar mensajes de alertas.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    /** Estable si el componente estará visible o no */
    visible: {
      type: Boolean,
      default: false,
    },
    /** Mensaje mostrado en el interior del componente */
    message: {
      type: String,
      default: () => '',
    },
    customIcon: {
      type: String,
      default: () => 'fa-bell-exclamation',
    },
    customIconColor: {
      type: String,
      default: () => 'secondary-18',
    },
    customColor: {
      type: String,
      default: () => 'secondary-18',
    },
    customBackgroundColor: {
      type: String,
      default: () => 'secondary-18',
    },
    customBorderColor: {
      type: String,
      default: () => 'secondary-39',
    },
    hyperlinkConfig: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style scope lang="scss">
@import '@/shared/scss/config/_colors.scss';

.hyperlink {
  text-decoration: underline;
  cursor: pointer;
}
.text-secondary-18 {
  color: #af6708;
}
.border-secondary-39 {
  border: 1px solid map-get($colors, 'secondary-39');
}
.border-green {
  border: 1px solid map-get($colors, 'green-200');
}
.bg-custom-green {
  background-color: map-get($colors, 'green-light-200');
}
</style>
